import type { Variant, VariantStyles } from './ScheduleList.types';
import { mergeVariantStyles } from './ScheduleList.utils';

const defaultStyles: VariantStyles = {
  scheduleDayItemContainer: {
    _notFirst: {
      marginTop: [10],
    },
  },
  header: {
    borderBottom: '1px solid',
    borderBottomColor: 'mono3',
  },
  headerText: {
    textAlign: 'center',
  },
  events: {},
  eventsStack: {
    width: '100%',
  },
  container: {},
  primaryBlockColumns: {
    width: '100%',
    marginTop: [0, null, 0],
  },
  primaryBlock: {
    container: {},
  },
  scheduleDateColumn: () => ({}),
  secondaryBlockColumns: {
    marginTop: [10],
  },
  secondaryBlock: {
    container: {
      spacing: 4,
    },
    durationBlockContainer: {},
    durationBlock: {
      textAlign: 'left',
    },
    calendarBlock: {
      width: ['auto', 'auto', '260px'],
      paddingX: ['0.75rem', '1rem', '1.5rem'],
    },
    directionBlock: {
      width: 'auto',
      paddingX: ['0.75rem', '1rem'],
    },
  },
};

export const variantStyles: Readonly<Record<Variant, VariantStyles>> = {
  stack: mergeVariantStyles(defaultStyles, {
    scheduleDayItemContainer: {
      marginTop: 10,
    },
    container: {},
    events: {
      paddingTop: '2.5rem',
    },
    eventsStack: {
      spacing: 0,
    },
    header: {
      paddingBottom: '0.5rem',
      marginBottom: '2.5rem',
    },
    headerText: {
      textAlign: 'center',
    },
    primaryBlockColumns: {
      span: 12,
    },
    primaryBlock: {
      container: {
        marginTop: 6,
      },
    },
    scheduleDateColumn: () => ({
      marginTop: [0],
      span: 12,
    }),
    secondaryBlockColumns: {
      marginTop: [0],
      span: 12,
    },
    secondaryBlock: {
      container: {
        alignItems: 'flex-start',
      },
      durationBlockContainer: {
        textAlign: 'left',
      },
      durationBlock: {
        color: 'mono10',
      },
      calendarBlock: {},
      directionBlock: {},
    },
  }),
  inline: mergeVariantStyles(defaultStyles, {
    scheduleDayItemContainer: {
      marginTop: [10],
    },
    container: {}, //{ span: [12, 10], offset: [null] },
    events: {},
    eventsStack: {
      spacing: 0,
    },
    header: {
      paddingBottom: 5,
    },
    headerText: {
      textAlign: ['center', null, 'left'],
    },
    scheduleDateColumn: (isToBeAnnounced: boolean) => ({
      span: isToBeAnnounced ? [12, 6] : [12, 3],
    }),
    primaryBlockColumns: {
      span: [12, 6],
    },
    primaryBlock: {
      container: {
        marginTop: [6, null, 0],
      },
    },
    secondaryBlockColumns: {
      span: [12, 3],
      marginTop: 0,
    },
    secondaryBlock: {
      container: {
        alignItems: 'flex-start',
        marginBottom: [0, null, '2.5rem'],
        marginTop: ['0.125rem'],
      },
      durationBlockContainer: {
        textAlign: 'left',
      },
      durationBlock: {
        marginTop: [5, 0],
        color: 'mono10',
        textAlign: 'left',
        fontWeight: 500,
      },
      calendarBlock: {},
      directionBlock: {},
    },
  }),
};
